import HolidayPackageSection from "@/Component/Common/HolidayPackageSection";

export default function CountrywiseCard({
  titleFirst = "",
  titleLast = "",
  description = "",
  packageList = [],
  moduleType = "Holiday",
}) {
  const isActivity = moduleType === "Activity";
  const listKey = isActivity ? "activityList" : "holidayList";
  const title = `${titleFirst || ""} ${titleLast || ""}`.trim();

  return (
    <HolidayPackageSection
      title={title}
      subtitle={description}
      data={{ [listKey]: packageList }}
      moduleType={isActivity ? "activity" : "holiday"}
      hideWhenEmpty
    />
  );
}
